var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton",style:({
    width: (_vm.width + "px"),
    height: (_vm.height + "px"),
    borderRadius: _vm.radius,
    display: _vm.inline ? 'inline-block' : 'block',
  })})}
var staticRenderFns = []

export { render, staticRenderFns }